{
  "update-password-pin-dialog": {
    "buttons": {
      "resend": "Gửi lại",
      "submit": "Xác nhận"
    },
    "text": {
      "enter-pin": "Vui lòng nhập mã PIN để xác nhận mật khẩu mới của bạn.",
      "in-second": "sau {{seconds}} giây",
      "password-updated": "Mật khẩu đã được cập nhật thành công!",
      "pin-via-email": "Mã PIN được gửi tới email của bạn",
      "pin-via-sms": "Mã PIN được gửi tới số điện thoại của bạn",
      "update-password": "Cập nhật mật khẩu"
    }
  }
}
